<template>
    <div>
        <el-tag><i class="el-icon-s-promotion">流量概览</i></el-tag>
        <div class="block">
            <el-date-picker
                    v-model="dataMonth"
                    type="monthrange"
                    @change="dateChange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份">
            </el-date-picker>
        </div>
        <el-row :gutter="20" style="margin-top:10px">
            <el-col :span="5">
                <el-card class="card-s">
                    <div class="card-content" style="margin-top:-10px">
                        <a style="font-size: 16px;">药品金额</a>
                    </div>
                    <div class="card-content">
                        <a href="#" style="font-size: 20px;color: cornflowerblue">{{money}}</a>
                        <div>
                            <a style="font-size: 16px;">环比:</a>
                            <a href="#" style="font-size: 20px;color: cornflowerblue">{{huanBi}}</a>&nbsp;
                            <a style="font-size: 16px;">同比:</a>
                            <a href="#" style="font-size: 20px;color: cornflowerblue">{{tongBi}}</a>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "BusinessStatistics",
        data() {
            return {
                authorization: localStorage.getItem('authorization'),
                dataMonth: "",
                startTime: "",
                endTime: "",
                money: "",
                huanBi: "",
                tongBi: "",
            }
        },
        methods: {
            dateChange(val) {
                this.startTime = val[0]
                this.endTime = val[1]
                if(this.startTime!="" && this.endTime!=""){
                    //this.queryBusiness();
                    this.axios.get('api-s/10062/?startTime=' + this.startTime + '&endTime=' + this.endTime, {
                        headers: {
                            Authorization: this.authorization
                        },
                    }).then(res => {
                        //alert(JSON.stringify(res.data.data))
                        this.money = res.data.data.money/100;
                        this.huanBi = res.data.data.huanBi;
                        this.tongBi = res.data.data.tongBi;
                    })

                }
                console.log(this.startTime)
                console.log("---"+this.endTime)
            },

        }
    }
</script>

<style>
    .card-content {
        text-align: center;
        margin-top: 5px;
    }

    .card-s {
        height: 100px;
        padding: 0
    }

</style>